"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_clock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "37949cf9-687b-434e-8000-7be826c5d3b0",
    x1: 89.18,
    y1: 61.86,
    x2: 128.99,
    y2: 101.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a6871c9-7790-462a-a61f-83db48cfec96",
    x1: 98.69,
    y1: 52.1,
    x2: 98.81,
    y2: 52.1,
    xlinkHref: "#37949cf9-687b-434e-8000-7be826c5d3b0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4e4957ac-91d2-4a7a-b4c0-3519e1ef1902",
    x1: 93.06,
    y1: 128.82,
    x2: 181.32,
    y2: 128.82,
    xlinkHref: "#37949cf9-687b-434e-8000-7be826c5d3b0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "259c0945-8eda-41bb-8562-c44adff1592c",
    x1: 107.02,
    y1: 84.77,
    x2: 168.9,
    y2: 146.65,
    xlinkHref: "#37949cf9-687b-434e-8000-7be826c5d3b0"
  })), /*#__PURE__*/React.createElement("title", null, "clock-hi"), /*#__PURE__*/React.createElement("g", {
    id: "5db3a230-e11e-4968-922e-07d58d0a5384",
    "data-name": "clock-hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "4097e47e-f07d-4591-be02-1712f4c73cc7",
    "data-name": "<Pfad>",
    x1: 166.03,
    y1: 96,
    x2: 154.5,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "dfba1913-68df-4e1d-8758-6ae462c19942",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 37,
    x2: 96,
    y2: 25.77,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "df6206d9-7391-4ad1-807f-4cc8ef1ba589",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 166.03,
    x2: 96,
    y2: 154.5,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "4f401e7b-23f2-46b7-ac95-697bb049cf32",
    "data-name": "<Pfad>",
    x1: 25.97,
    y1: 96,
    x2: 37.5,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("line", {
    id: "5800e0c5-e5d2-404f-8f9a-174bf557fa8b",
    "data-name": "<Pfad>",
    x1: 126.09,
    y1: 43.3,
    x2: 130.67,
    y2: 35.01,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "407d5e72-3dd1-4f89-a4b3-d95dd4aa03d2",
    "data-name": "<Pfad>",
    x1: 148.77,
    y1: 65.29,
    x2: 156.68,
    y2: 60.67,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "c9eb4984-666c-492c-be7d-90a41b7d6b3d",
    "data-name": "<Pfad>",
    x1: 148.7,
    y1: 126.09,
    x2: 156.99,
    y2: 130.67,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "d1acfb91-482c-422a-bc2d-f9ede12eef9a",
    "data-name": "<Pfad>",
    x1: 126.71,
    y1: 148.77,
    x2: 131.33,
    y2: 156.68,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "9c2187d6-0288-4e28-b315-528c6957d48d",
    "data-name": "<Pfad>",
    x1: 65.91,
    y1: 148.7,
    x2: 61.33,
    y2: 156.99,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "4b698432-fce1-4013-a13a-6c345656639a",
    "data-name": "<Pfad>",
    x1: 43.23,
    y1: 126.71,
    x2: 35.32,
    y2: 131.33,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "3c9c9a6d-94c9-4484-a64f-74d7d4dac2ff",
    "data-name": "<Pfad>",
    x1: 43.3,
    y1: 65.91,
    x2: 35.01,
    y2: 61.33,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "01fe6a68-91be-4037-9783-a29be503f0c6",
    "data-name": "<Pfad>",
    x1: 65.29,
    y1: 43.23,
    x2: 60.67,
    y2: 35.32,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "1627cb11-14f5-441c-b468-b25ab9883e7c",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 96,
    x2: 140.5,
    y2: 96,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "f9edbd22-8f08-41db-a211-87ef1081fb3e",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 96,
    x2: 96,
    y2: 55,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.5,98H96a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4h44.5a4,4,0,0,0,3.86-5A4,4,0,0,1,140.5,98Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96,26A70,70,0,1,1,26,96,70.08,70.08,0,0,1,96,26m0-10a80,80,0,1,0,80,80A80,80,0,0,0,96,16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,24A70.08,70.08,0,0,0,26,94c0,.34,0,.67,0,1A70,70,0,0,1,166,95c0-.33,0-.66,0-1A70.08,70.08,0,0,0,96,24Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,92,98.85,52.19A4,4,0,0,1,100,55V92Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#37949cf9-687b-434e-8000-7be826c5d3b0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,52.15l-.1-.1h0Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#9a6871c9-7790-462a-a61f-83db48cfec96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,26a70,70,0,1,0,46.55,122.22L93.06,98.73h0A4,4,0,0,0,96,100h44.5a4,4,0,0,0,2.86-6.79h0l20.38,20.38A70,70,0,0,0,96,26Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,128.75l-.06.14Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#4e4957ac-91d2-4a7a-b4c0-3519e1ef1902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,93.21A4,4,0,0,1,140.5,100H96a4,4,0,0,1-2.91-1.27h0l49.49,49.49a70.08,70.08,0,0,0,21.21-34.63L143.38,93.21Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#259c0945-8eda-41bb-8562-c44adff1592c)"
  })));
}

var _default = ic_clock;
exports.default = _default;